export default __webpack_public_path__ + "static/media/email.c4116a84.svg";